'use client';

import { Box, Typography, Button } from '@wishket/design-system';
import { twJoin } from 'tailwind-merge';
import { usePathname } from 'next/navigation';

import { attentionGrabCardProps } from './constants';

import { Image, Link } from '@/shared/Components';
import { useAuth } from '@/shared/hooks';
import { PATH } from '@/shared/constants';

const AttentionGrabCard = () => {
  const { isAuth } = useAuth();
  const pathname = usePathname();
  const { description, buttonText, buttonLink } =
    attentionGrabCardProps[isAuth ? 'member' : 'guest'];

  const finalButtonLink =
    !isAuth && pathname ? `${buttonLink}?next=${pathname}` : buttonLink;

  return (
    <Box
      className={twJoin(
        'flex h-[230px] min-w-[210px] flex-col gap-4 rounded-2xl bg-w-bluegray-10 p-5',
        'tablet:h-[238px] tablet:min-w-[360px] tablet:gap-6 tablet:p-8 tablet:pt-6'
      )}
    >
      <Box
        className={twJoin(
          'flex flex-col items-center justify-between gap-2',
          'tablet:gap-4'
        )}
      >
        <Image
          className="h-[64px] w-[124px]"
          src={`${PATH.MEDIA_YOZM_IMAGE}/face_smile.gif`}
          alt="face_smile"
          width={124}
          height={64}
          unoptimized
        />
        <Typography
          variant="body1"
          className={twJoin('text-center font-medium', 'tablet:typo-subTitle2')}
        >
          {description.prefix}
          <span
            className={twJoin(
              'whitespace-pre-line font-bold',
              'tablet:whitespace-normal'
            )}
          >
            {description.highlight}
          </span>
          {description.suffix}
        </Typography>
      </Box>
      <Link href={finalButtonLink}>
        <Button variant="solid" size="md" className="w-full">
          {buttonText}
        </Button>
      </Link>
    </Box>
  );
};

export default AttentionGrabCard;
